import Card from "components/card";

const NotFound = () => {
  return (
    <div>
      <div className="relative float-right h-full min-h-screen w-full !bg-lightPrimary dark:!bg-navy-900">
        <main className={`mx-auto min-h-screen`}>
          <div className="relative flex">
            <div className="mx-auto flex min-h-full w-full flex-col justify-start pt-12 md:max-w-[75%] lg:h-screen lg:max-w-[1013px] lg:px-8 lg:pt-0 xl:h-[100vh] xl:max-w-[1383px] xl:px-0 xl:pl-[70px]">
              <div className="mx-auto mb-auto flex w-full flex-col pl-5 pr-5 md:w-[544px]">
                <div>
                  <div className="mt-5 grid h-full grid-cols-1 gap-5">
                    <Card
                      extra={
                        "w-full h-full p-4 sm:overflow-x-auto flex justify-center"
                      }
                    >
                      <div className="flex flex-wrap items-center justify-center py-20 text-center">
                        <div className="mb-6 w-full">
                          <span className="text-2xl font-bold text-gray-800 dark:text-white">
                            Pagina non trovata
                          </span>
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              </div>
              <div className="z-[5] mx-auto flex w-full max-w-screen-sm flex-col items-center justify-between px-[20px] pb-4 lg:mb-6 lg:max-w-[100%] lg:flex-row xl:mb-2 xl:w-[1310px] xl:pb-6">
                <p className="mx-auto mb-6 text-center text-sm text-gray-400 lg:mb-0">
                  ©{1900 + new Date().getYear()} Proxima. Tutti i diritti
                  riservati
                </p>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default NotFound;
